export default {
  correctFloatNumber(floatNumber: number): number {
    return Math.round(floatNumber * 100) / 100;
  }
};
